import { postToApi } from '..'

export async function signInApi(
  walletAddress: string,
  message: string,
  signature: string,
) {
  return await postToApi('/staking/users/sign_in', {
    signature,
    message,
    pubkey: walletAddress,
  })
}
